import type { ReactNode } from 'react';
import Link from 'next/link';
import { MP_BUTTON_NAVY } from '@/components/(user)/common/layout';

interface EmptyStateProps {
  title: string;
  description?: string;
  /** 남색 CTA. 없으면 문구만. */
  action?: { label: string; href: string };
  /** `action` 대신 임의의 조각을 둘 때(버튼 여러 개 등). */
  children?: ReactNode;
  /** 카드 안에 들어가면 `compact`(패딩 32/22), 화면 한가운데면 기본(56/20). */
  size?: 'default' | 'compact';
  className?: string;
}

/**
 * 빈 상태(계획서 G8) — 문구 두 줄(16px/700 + 14px/500 alternative) + 필요하면 남색 CTA. 이미지 없음.
 * 기획 `body.html` 265~271(목록) · 108~111(홈 할 일).
 */
const EmptyState = ({ title, description, action, children, size = 'default', className = '' }: EmptyStateProps) => (
  <div className={`text-center ${size === 'compact' ? 'px-[22px] py-8' : 'px-5 py-14'} ${className}`}>
    <p className={`font-bold text-mp-ink ${size === 'compact' ? 'text-[14px] tracking-[-0.01em]' : 'text-[16px]'}`}>{title}</p>
    {description && <p className={`mt-1.5 font-medium text-mp-alt ${size === 'compact' ? 'text-[13px]' : 'text-[14px]'}`}>{description}</p>}
    {action && (
      <Link href={action.href} className={`${MP_BUTTON_NAVY} mt-[18px] rounded-[10px] px-[18px] py-3 text-[14px]`}>
        {action.label}
      </Link>
    )}
    {children}
  </div>
);

export default EmptyState;
